/* TODO: t() */
/* eslint-disable @typescript-eslint/no-floating-promises */
import React, { useState } from 'react';
import { View, StyleSheet } from 'react-native';
import { Button, Text, ColorPicker, Modal, BooleanInput } from '../uiold';

import { WHITE_RGB_COLOR } from '../uiold/Constants';
import { Account, RGBColor, Settings } from '../../types/shared/Account';
import { Season } from '../../types/shared/Season';

import AccountActions from '../../support/AccountActions';
import { postJSON } from '../../support/Fetch';
import { showSuccess } from '../App/AppAlert';

type Props = {
  onHide: () => void;
  isModalVisible: boolean;
  account: Account | undefined;
  season: Season | undefined;
};

export default function ProfileOptionsDialog(props: Props) {
  let { onHide, isModalVisible, account } = props;

  let [backgroundColor, setBackgroundColor] = useState<RGBColor>(
    account?.settings?.profiles?.backgroundColor ?? WHITE_RGB_COLOR,
  );
  let [defaultDisplayByDate, setDefaultDisplayByDate] = useState(
    account?.settings?.profiles?.defaultDisplayByDate ?? false,
  );

  let onBackgroundColorChange = (color: RGBColor) => {
    setBackgroundColor(color);
  };

  if (!account) {
    return null;
  }

  let onSave = () => {
    if (account) {
      let oldSettings = account?.settings;
      let newSettings: Settings = {
        ...oldSettings,
        profiles: {
          backgroundColor,
          defaultDisplayByDate: defaultDisplayByDate,
        },
      };
      AccountActions.updateAccount({ settings: newSettings });
      // TODO: Do we need to deal with season here?
      postJSON(`/api/accounts/${account.id}/embedSettings`, newSettings);
      showSuccess('Vendor Profile settings saved.');
      onHide();
    }
  };

  return (
    <Modal isVisible={isModalVisible} onClose={onHide} scrollBehavior="outside">
      <Modal.Header title="Vendor Profile Embed Options" />
      <Modal.Body>
        <View style={styles.modalContent}>
          <View style={styles.optionsItem}>
            <BooleanInput
              label="Select how you would like the default for your vendors to display"
              onChange={(value) => {
                setDefaultDisplayByDate(value);
              }}
              value={defaultDisplayByDate}
              falseParams={{ label: 'Display All Vendors' }}
              trueParams={{ label: 'Display Vendors by Date' }}
            />
          </View>
          <View style={styles.optionsItem}>
            <Text style={styles.colorLabel}>Background Color</Text>
            <ColorPicker
              selectedColor={backgroundColor}
              handleChange={onBackgroundColorChange}
            />
          </View>
        </View>
      </Modal.Body>
      <Modal.Footer>
        <Button title="Cancel" onPress={onHide} />
        <Button title="Save" onPress={onSave} isPrimary />
      </Modal.Footer>
    </Modal>
  );
}

let styles = StyleSheet.create({
  modalContent: {
    flexDirection: 'column',
    flex: 1,
  },
  optionsItem: {
    marginVertical: 8,
  },
  colorLabel: {
    marginBottom: 8,
  },
});
